import React, { FC, useEffect, useState } from 'react';
import { Box, Card, Typography, Collapse, Button, TextField, FormControl, InputLabel, Select, OutlinedInput, MenuItem, Checkbox, ListItemText, Chip, Backdrop, IconButton } from '@mui/material';
import Grid from '@mui/material/Grid2';
import useDataPermission from '../../hooks/useDataPermission';
import { Controller, useForm } from 'react-hook-form';
import useDataArea from '../../hooks/useDataArea';
import useDataCompanyUsers from '../../hooks/useDataCompanyUsers';
import { useNavigate } from 'react-router-dom';
import URLS from '../../enums/route';
import ChipSelector from '../Common/ChipSelector';
import FreeFieldCreate from './FreeFieldCreate';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import { useAuth } from '../../store/auth.store';
import ModalWrapper from '../Modals/ModalWrapper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import introJs from 'intro.js';
import { BussniseTour4 } from '../../enums/tourEnums';
import { useTour } from '../../provider/TourGuide';
import CloseIcon from '@mui/icons-material/Close';

interface UserCardProps {

}

interface IFormInput {
    fullName: string;
    phone: string
    areas: string[];
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;



const UserCardMock:FC<UserCardProps> = () => {
    const [active, setActive] = useState(false);
    const [expanded, setExpanded] = useState(true);
    const [openEdit, setOpenEdit] = useState(true)
    const navigate = useNavigate()
    const { data:areas } = useDataArea();
    const {update,unpublishUser} = useDataCompanyUsers()
    const {data: Tags} = useDataPermission()
    const [selectedPermission, setSelectedPermission] = useState<IPermission | null>()
    const {user} = useAuth()
    const isAllowEdit = user?.permission?.permissionDetaileds[0]?.isArchitecture
    const {onExitBussnies,setBussniesNumber} = useTour()
    const { control, handleSubmit, setValue, formState: { errors } } = useForm<IFormInput>({
        defaultValues: {
            fullName: '',
            areas: [],
        },
    });

    const handleUnpublish = () => {
        setOpenEdit(false)
        setExpanded(false)
        setActive(false)

    }

    useEffect(() => {
        if (openEdit) {
            setValue('fullName', 'שם העובד'); 
            setValue('phone', 'מס׳ טלפון העובד'); 
        }
    }, [openEdit, setValue]);

    useEffect(() => {
        if (!localStorage.getItem("bussnies") && user?.permission?.permissionDetaileds?.[0]?.isArchitecture ) {
                setTimeout(() => {
                    let didComplete = false;
                    const intro = introJs()
                    .onskip(() => {
                        didComplete = true;
                        onExitBussnies()
                        setBussniesNumber(0);
                      })
                    .onexit(() => {
                        if (didComplete) {
                            return;
                        }
                        navigate(URLS.BUSSNIES.LINK)
                        onExitBussnies();
                        setBussniesNumber(0)
                    })
                
                    intro.setOptions({
                        ...BussniseTour4,
                        scrollToElement: false,
                        disableInteraction: true,
                        showBullets: false,
                    });
                
                    intro.start();
                },500)
            }
        }, 
    []);

    
    return (
        <>
        <Card sx={{ display: 'flex', flexDirection: 'column', gap: '10px', margin: '10px 0', padding: '10px' }} id={'bussnies4'}>
            <form >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'center', width:'100%'}}>
                        <Box>
                            {!openEdit &&
                                <Box sx={{display:'flex', gap:'10px'}}>
                                    <Typography color='#154D72' fontWeight={700} lineHeight={'21px'} fontSize={'15px'}>שם העובד</Typography>
                                </Box>
                            }
                   
                            {!expanded &&
                                <>
                                    <Typography color='#436F7C' fontSize={'13px'} fontWeight={400} lineHeight={'19.5px'}>מס׳ טלפון העובד</Typography>
                                </>
                            }
                        </Box>
                        {user?.permission?.permissionDetaileds[0]?.isAccounting &&
                          <>
                            {openEdit ?
                            <Box sx={{display:'flex', gap:'5px', mb:'20px'}}>
                                <IconButton
                                    onClick={(e) => {
                                        e.stopPropagation(); 
                                        setOpenEdit(false);
                                    }}
                                >
                                    <CloseIcon/>
                                </IconButton>
                                <Button 
                                    onClick={() => setActive(true)}
                                    variant='outlined'
                                    color='info'
                                    endIcon={
                                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Component 3">
                                            <g id="Icon">
                                                <path 
                                                d="M3 6.5H21H3Z" 
                                                fill="#FF32BB" 
                                                />
                                                <path 
                                                d="M16 6.5V5.7C16 4.5799 16 4.01984 15.782 3.59202C15.5903 3.21569 15.2843 2.90973 14.908 2.71799C14.4802 2.5 13.9201 2.5 12.8 2.5H11.2C10.0799 2.5 9.51984 2.5 9.09202 2.71799C8.71569 2.90973 8.40973 3.21569 8.21799 3.59202C8 4.01984 8 4.5799 8 5.7V6.5M10 12V17M14 12V17M3 6.5H21M19 6.5V17.7C19 19.3802 19 20.2202 18.673 20.862C18.3854 21.4265 17.9265 21.8854 17.362 22.173C16.7202 22.5 15.8802 22.5 14.2 22.5H9.8C8.11984 22.5 7.27976 22.5 6.63803 22.173C6.07354 21.8854 5.6146 21.4265 5.32698 20.862C5 20.2202 5 19.3802 5 17.7V6.5" 
                                                stroke="#FF32BB" 
                                                strokeWidth="2" 
                                                strokeLinecap="round" 
                                                strokeLinejoin="round" 
                                                />
                                            </g>
                                            </g>
                                        </svg>
                                    }
                                    sx={{
                                        height:'35px',
                                        whiteSpace:'nowrap'
                                    }}
                                >
                               מחק עובד
                                </Button>
                                <Button 
                                    variant='contained'
                                    type='submit'
                                    endIcon={
                                        <CheckCircleOutlineRoundedIcon sx={{ height: '25px', width: '25px' }} />
                                    }
                                    sx={{
                                        height:'35px'
                                    }}
                                >
                                שמירה
                                </Button>
                            </Box>
                            :
                            <>
                            {(isAllowEdit ) &&
                               <Box sx={{display:'flex', gap:'5px', cursor:'pointer'}} onClick={(e) => {
                                    e.stopPropagation(); 
                                    setExpanded(true);
                                    setOpenEdit(!openEdit);
                                }}>
                                    {expanded && (
                                        <Typography fontWeight={700} fontSize={15} color='primary' lineHeight={'21px'}>
                                            עריכה
                                        </Typography>
                                    )}
                                    <img src={`${process.env.REACT_APP_MEDIA}/editBus.svg`} width={'24px'} height={'24px'}/>
                                </Box>
                            }
                         
                            </>
                      
                            }
                          </>
                        }
                      
                    
        
                    </Box>
                </Box>
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <Box sx={{ padding: '10px' }}>
                        <Grid container spacing={2} direction="column">
                            <Grid   container justifyContent="flex-start" alignItems="center">
                                <Grid  size={2.5}>
                                <Typography align="right" color='#154D72' fontSize={'15px'} lineHeight={'19px'} fontWeight={700}>
                                שם מלא
                                </Typography>
                                </Grid>
                                <Grid  size={9.5}>
                                    {openEdit ?
                                        <Controller
                                            name="fullName"
                                            control={control}
                                            render={({ field }) => (
                                                <TextField {...field} error={!!errors.fullName} helperText={errors.fullName ? 'full name is required' : ''} />
                                            )}
                                            rules={{ required: 'fullName is required' }}
                                        />
                                    :
                                        <Typography variant="body1"  color='#546D79'>שם העובד</Typography>
                                    }
                                </Grid>
                            </Grid>
                            <Grid   container justifyContent="flex-start" alignItems="center">
                                <Grid  size={2.5}>
                                    <Typography align="right" color='#154D72' fontSize={'15px'} lineHeight={'19px'} fontWeight={700}>
                                    מייל
                                    </Typography>
                                </Grid>
                                <Grid  size={9.5}>
                                    <Typography variant="body1"  color='#546D79'>אימייל העובד</Typography>
                                </Grid>
                            </Grid>
                            <Grid   container justifyContent="flex-start" alignItems="center">
                                <Grid  size={2.5}>
                                <Typography align="right" color='#154D72' fontSize={'15px'} lineHeight={'19px'} fontWeight={700}>
                                    טלפון
                                </Typography>
                                </Grid>
                                <Grid  size={9.5}>
                                {openEdit ?
                                        <Controller
                                            name="phone"
                                            control={control}
                                            render={({ field }) => (
                                                <TextField {...field} error={!!errors.phone} helperText={errors.phone ? 'טלפון שדה חובה' : ''} />
                                            )}
                                            rules={{ required: 'טלפון שדה חובה' }}
                                        />
                                    :
                                        <Typography variant="body1" color='#546D79'>מס׳ טלפון העובד</Typography>
                                    }
                                    
                                </Grid>
                            </Grid>
                            {!user?.isPayCustomer &&
                               <Grid  container justifyContent="flex-start" alignItems="center">
                                    <Grid  size={2.5}>
                                
                                    <Typography align="right" color='#154D72' fontSize={'15px'} lineHeight={'19px'} fontWeight={700}>
                                        שייוך לסניף
                                    </Typography>
                                    </Grid>
                                    <Grid  size={9.5}>
                                        <Box sx={{
                                            border:'1px solid #80A8B6', 
                                            borderRadius:'14px',
                                            padding:'16.5px 14px',
                                            maxWidth: '223px', 
                                            display:'flex',
                                            justifyContent:'space-between'
                                            }}
                                        >
                                        <Typography variant="body1" color='black' fontSize={'15px'}>
                                            כל הסניפים
                                        </Typography>
                                        <KeyboardArrowDownIcon sx={{color:'#2F4B6C'}}/>
                                        </Box>
                                    </Grid>
                                </Grid>
                            }
                            {user?.isPayCustomer &&
                                <Grid  container justifyContent="flex-start" alignItems="center">
                                    <Grid  size={2.5}>
                                    <Typography align="right" color='#154D72' fontSize={'12px'} lineHeight={'19px'} fontWeight={700}>
                                        שייוך לסניף
                                    </Typography>
                                    </Grid>
                                    <Grid  size={9.5}>
                                        <Typography variant="body1" color='#546D79' fontSize={'13px'}>
                                            {/* {item?.company} */}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            }
                        </Grid>
                        {openEdit &&
                            <Box sx={{display:'flex', gap:'40px', mt:'20px'}}>
                                <Typography align="right" color='#154D72' fontSize={'12px'} lineHeight={'19px'} fontWeight={700}>
                                הרשאה
                                </Typography>
                                <Grid container spacing={'5px'}>
                                    {Tags?.map((item) => {
                                        if(!item.isEditable){
                                            return (
                                                <Grid key={item.id} >
                                                    <ChipSelector item={item} handleClick={(e) => setSelectedPermission(e)} isSelected={item.id === 3}/>
                                                </Grid>
                                            )
                                        }
                                    })}
                                    <Grid>
                                        <Chip
                                            label={'אחמ"ש'}
                                            variant={'outlined'} 
                                            style={{color: '#418CDD', borderColor:'#418CDD'}} 
                                        />
                                    </Grid>
                                    <Grid>
                                        <Chip
                                            label={'מנהל רכש'}
                                            variant={'outlined'} 
                                            style={{color: '#269E36', borderColor:'#269E36'}} 
                                        />
                                    </Grid>
                                    <Grid>
                                 
                                    </Grid>
                                </Grid>
                            </Box>
                        }
                        {
                            openEdit &&

                            <Typography fontSize={'13px'} fontWeight={400} lineHeight={'19px'} color='#80A8B6' sx={{paddingTop:'10PX'}}>
                            הרשאות מנהל סניף: ביצוע הזמנות, צפייה בהיסטוריית הזמנות, אישור קבלת מוצר וסגירת קריאה, פתיחת קריאות שירות
                            </Typography>
                        }
                    </Box>
                </Collapse>
            </form>
        </Card>
        <ModalWrapper 
            active={active} 
            setActive={setActive}
            component={
                <Typography color='info' fontSize={'20px'} fontWeight={700} lineHeight={'28px'}>
                  מחק עובד
                </Typography>
            }
        >
            <Box>
                <Typography color='#436F7C' fontSize={'15px'} fontWeight={700} lineHeight={'22.5px'}>
                שימו לב!
                </Typography>
                <Typography color='#546D79'>
                בלחיצה על <b style={{color:'#436F7C', fontSize:"15px", fontWeight:700}}>מחיקה</b>, העובד הנוכחי ימחק ולא ניתן יהיה לשחזרו.
                </Typography>
                <Button 
                    variant='outlined' 
                    color='info'
                    fullWidth
                    endIcon={
                        <img src={`${process.env.REACT_APP_MEDIA}/trshIcon.svg`} />
                    }
                    onClick={() => handleUnpublish()}
                    sx={{
                        mt:'30px',
                    }}
                >
                מחיקה
                </Button>
                <Button
                    onClick={() => setActive(false)}
                    sx={{
                        mt:'20px'
                    }}
                    fullWidth
                >
                חזרה 
                </Button>
            </Box>
        </ModalWrapper>
        
        </>

    );
};

export default UserCardMock;